/** A labelled on / off preference of "My data": the name, a line about it, and the switch. */
export function PrefSwitch({
  label,
  about,
  checked,
  disabled = false,
  onChange,
}: {
  label: string;
  about: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="flex items-center justify-between gap-4 text-[14px]">
      <span className="flex flex-col gap-1">
        <span className="font-bold">{label}</span>
        <span className="text-[13px] text-ink/75">{about}</span>
      </span>
      <input
        type="checkbox"
        role="switch"
        aria-checked={checked}
        className="h-6 w-6 flex-none accent-gold"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
    </label>
  );
}
